import React from "react";
import "../css/marquee.css";

const MarqueeText = () => {
  const slogans = [
    "Crafting bold Indian flavours since 1952",
    "Trusted by chefs and dealers nationwide",
    "Spices that taste like home",
    "Bulk and dealer enquiries welcome",
  ];

  return (
    <div className="marquee-container">
      <div className="marquee">
        <div className="marquee-content">
          {slogans.map((slogan, index) => (
            <span key={index} className="marquee-item">
              {slogan}
            </span>
          ))}
          {/* Repeat to create continuous loop effect */}
          {slogans.map((slogan, index) => (
            <span key={`repeat-${index}`} className="marquee-item">
              {slogan}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarqueeText;



// WEBPACK FOOTER //
// ./src/components/MarqueeText.js